// List of icons that are used in the app and need to be preloaded
const iconifyIcons = {
  'mdi:arrow-left': 'mdi:arrow-left',
  'mdi:arrow-right': 'mdi:arrow-right',
  'eva:chevron-right-fill': 'eva:chevron-right-fill',
  'eva:chevron-left-fill': 'eva:chevron-left-fill',
  'eva:chevron-down-fill': 'eva:chevron-down-fill',
  'eva:arrow-ios-downward-fill': 'eva:arrow-ios-downward-fill',
  'eva:arrow-ios-forward-fill': 'eva:arrow-ios-forward-fill',
  'eva:options-2-fill': 'eva:options-2-fill',
  'ion:refresh-outline': 'ion:refresh-outline',
  'uil:calender': 'uil:calender',
  'et:search': 'et:search',
  'line-md:download-loop': 'line-md:download-loop',
  'eva:checkmark-outline': 'eva:checkmark-outline',
  'mingcute:arrow-to-left-line': 'mingcute:arrow-to-left-line',
  'mingcute:arrow-to-right-line': 'mingcute:arrow-to-right-line',
  'mingcute:right-line': 'mingcute:right-line',
  'mingcute:left-line': 'mingcute:left-line',
  'feather:copy': 'feather:copy',
  'feather:check': 'feather:check',
  'bi:check-circle-fill': 'bi:check-circle-fill',
  'cryptocurrency-color:usdt': 'cryptocurrency-color:usdt',
  'emojione:money-with-wings': 'emojione:money-with-wings',
  'mdi:close': 'mdi:close',
  'mingcute:left-fill': 'mingcute:left-fill',
  'mingcute:right-fill': 'mingcute:right-fill',
  'carbon:filter': 'carbon:filter',
  'ion:information-circle-outline': 'ion:information-circle-outline',
  'ion:eye': 'ion:eye',
  'ion:eye-off': 'ion:eye-off',
  'proicons:document': 'proicons:document',
  'healthicons:contraceptive-diaphragm': 'healthicons:contraceptive-diaphragm',
  'game-icons:new-shoot': 'game-icons:new-shoot',
  'iconoir:empty-page': 'iconoir:empty-page',
  'mdi:email': 'mdi:email',
  'mdi:shield-lock': 'mdi:shield-lock',
  'mdi:phone': 'mdi:phone',
  'line-md:menu-unfold-left': 'line-md:menu-unfold-left',
  'line-md:menu-unfold-right': 'line-md:menu-unfold-right',
  'majesticons:logout': 'majesticons:logout',
  'eva:settings-2-outline': 'eva:settings-2-outline',
  'carbon:checkmark': 'carbon:checkmark',
  'carbon:copy': 'carbon:copy',
  'grommet-icons:analytics': 'grommet-icons:analytics',
  'fluent:receipt-cube-24-regular': 'fluent:receipt-cube-24-regular',
  'material-symbols-light:timeline': 'material-symbols-light:timeline',
  'solar:wallet-bold': 'solar:wallet-bold',
  'icon-park-outline:funds': 'icon-park-outline:funds',
  'lets-icons:order': 'lets-icons:order',
  'eva:alert-circle-outline': 'eva:alert-circle-outline',
  'eva:arrow-ios-back-fill': 'eva:arrow-ios-back-fill',
  'eva:plus-fill': 'eva:plus-fill',
  'eva:minus-fill': 'eva:minus-fill',
  'eva:arrow-ios-upward-fill': 'eva:arrow-ios-upward-fill',
  'eva:arrow-upward-fill': 'eva:arrow-upward-fill',
  'eva:arrow-downward-fill': 'eva:arrow-downward-fill',
  'mdi:alert-circle-outline': 'mdi:alert-circle-outline',
  'vaadin:golf': 'vaadin:golf',
  'eva:more-vertical-fill': 'eva:more-vertical-fill',
  'fluent:edit-16-regular': 'fluent:edit-16-regular',
  'mdi:clock-edit-outline': 'mdi:clock-edit-outline',
  'heroicons:banknotes': 'heroicons:banknotes',
  'healthicons:low-bars': 'healthicons:low-bars',
  'akar-icons:stop': 'akar-icons:stop',
  'ic:baseline-auto-mode': 'ic:baseline-auto-mode',
  'mingcute:target-fill': 'mingcute:target-fill',
  'tabler:forbid': 'tabler:forbid',
  'ion:arrow-forward-outline': 'ion:arrow-forward-outline',
  'ion:arrow-back-outline': 'ion:arrow-back-outline',
  'mdi:account': 'mdi:account',
  'bi:hourglass-top': 'bi:hourglass-top',
  'ph:coins': 'ph:coins',
  'eva:trending-up-fill': 'eva:trending-up-fill',
  'eva:trending-down-fill': 'eva:trending-down-fill',
  'fluent:extended-dock-20-regular': 'fluent:extended-dock-20-regular',
  'mdi:check': 'mdi:check',
  'iconamoon:trend-up': 'iconamoon:trend-up',
  'iconamoon:trend-down': 'iconamoon:trend-down',
  'iconamoon:edit': 'iconamoon:edit',
  'solar:calendar-date-bold': 'solar:calendar-date-bold',
  'material-symbols:schedule': 'material-symbols:schedule',
  'akar-icons:schedule': 'akar-icons:schedule',
  'dashicons:hourglass': 'dashicons:hourglass',
  'bxs:hand': 'bxs:hand',
  'solar:star-bold': 'solar:star-bold',
  'material-symbols:error': 'material-symbols:error',
  'iconamoon:cloud-error': 'iconamoon:cloud-error',
  'icon-park-outline:right-c': 'icon-park-outline:right-c',
  'icon-park-outline:left-c': 'icon-park-outline:left-c',
  'material-symbols:arrow-forward': 'material-symbols:arrow-forward',
  'material-symbols:arrow-back': 'material-symbols:arrow-back',
  'clarity:edit-line': 'clarity:edit-line',
  'material-symbols:edit': 'material-symbols:edit',
  'iconoir:filter-solid': 'iconoir:filter-solid',
  'mdi:recent': 'mdi:recent',
  'lucide:bot': 'lucide:bot',
  'bxs:user': 'bxs:user',
  'mingcute:safety-certificate-fill': 'mingcute:safety-certificate-fill',
  'typcn:flow-children': 'typcn:flow-children',
  'carbon:previous-filled': 'carbon:previous-filled',
  'gravity-ui:list-ul': 'gravity-ui:list-ul',
  'gravity-ui:bars-descending-align-left-arrow-down':
    'gravity-ui:bars-descending-align-left-arrow-down',
  'solar:calendar-mark-broken': 'solar:calendar-mark-broken',
  'tabler:affiliate': 'tabler:affiliate',
  'ph:seal-percent': 'ph:seal-percent',
  'uiw:right': 'uiw:right',
  'mingcute:idcard-fill': 'mingcute:idcard-fill',
  'pajamas:preferences': 'pajamas:preferences',
  'solar:key-bold': 'solar:key-bold',
  'solar:bell-bing-bold-duotone': 'solar:bell-bing-bold-duotone',
  'material-symbols:lock': 'material-symbols:lock',
  'mdi:users': 'mdi:users',
  'carbon:password': 'carbon:password',
  'ic:baseline-phone': 'ic:baseline-phone',
  'tabler:language': 'tabler:language',
  'lets-icons:color-mode': 'lets-icons:color-mode',
  'grommet-icons:currency': 'grommet-icons:currency',
  'formkit:time': 'formkit:time',
  'ri:time-zone-fill': 'ri:time-zone-fill',
  'tabler:separator-vertical': 'tabler:separator-vertical',
  'material-symbols:decimal-decrease': 'material-symbols:decimal-decrease',
  'ph:password-bold': 'ph:password-bold',
  'ic:baseline-email': 'ic:baseline-email',
  'lets-icons:check-fill': 'lets-icons:check-fill',
  'carbon:close-filled': 'carbon:close-filled',
  'solar:user-block-rounded-bold-duotone': 'solar:user-block-rounded-bold-duotone',
  'streamline:discount-percent-fire': 'streamline:discount-percent-fire',
  'material-symbols:partner-exchange': 'material-symbols:partner-exchange',
  'meteocons:pollen-tree-fill': 'meteocons:pollen-tree-fill',
  'mage:pin-fill': 'mage:pin-fill',
  'humbleicons:arrow-main-split-side': 'humbleicons:arrow-main-split-side',
  // Social Media
  'skill-icons:instagram': 'skill-icons:instagram',
  'logos:facebook': 'logos:facebook',
  'logos:youtube-icon': 'logos:youtube-icon',
  'logos:tiktok-icon': 'logos:tiktok-icon',
  'logos:linkedin-icon': 'logos:linkedin-icon',
  'logos:telegram': 'logos:telegram',
  'logos:reddit-icon': 'logos:reddit-icon',
  'logos:pinterest': 'logos:pinterest',
  'logos:whatsapp-icon': 'logos:whatsapp-icon',
  'cib:vk': 'cib:vk',
  'cib:line': 'cib:line',
  'ri:twitter-x-fill': 'ri:twitter-x-fill',
  'mdi:auto-fix': 'mdi:auto-fix',
  'mdi:hand-coin': 'mdi:hand-coin',
  'solar:chat-line-bold': 'solar:chat-line-bold',
  // Notifications
  'grommet-icons:secure': 'grommet-icons:secure',
  'streamline-ultimate:trading-pattern-up-bold': 'streamline-ultimate:trading-pattern-up-bold',
  'mdi:partnership-outline': 'mdi:partnership-outline',
  'bxs:lock': 'bxs:lock',

  // Affiliates
  'simple-icons:adblock': 'simple-icons:adblock',
  'fa6-solid:medal': 'fa6-solid:medal',
  'carbon:result': 'carbon:result',
  'oui:users': 'oui:users',
  'ri:list-check-2': 'ri:list-check-2',
  'grommet-icons:money': 'grommet-icons:money',
  'material-symbols:campaign': 'material-symbols:campaign',
  'material-symbols:history': 'material-symbols:history',
  'mdi:gold': 'mdi:gold',
  'noto:military-medal': 'noto:military-medal',
  'logos:redhat-icon': 'logos:redhat-icon',
  'material-symbols:add-task': 'material-symbols:add-task',
  'twemoji:trophy': 'twemoji:trophy',
  'hugeicons:chart-evaluation': 'hugeicons:chart-evaluation',
  'tdesign:undertake-transaction': 'tdesign:undertake-transaction',
  'ph:users-bold': 'ph:users-bold',
  'material-symbols:finance': 'material-symbols:finance',
  'heroicons:calculator-16-solid': 'heroicons:calculator-16-solid',
  'solar:trash-bin-minimalistic-bold': 'solar:trash-bin-minimalistic-bold',
  'ph:ranking': 'ph:ranking',
  'fluent-emoji:1st-place-medal': 'fluent-emoji:1st-place-medal',
  'fluent-emoji:2nd-place-medal': 'fluent-emoji:2nd-place-medal',
  'fluent-emoji:3rd-place-medal': 'fluent-emoji:3rd-place-medal',
  // Temp
  'iconamoon:mode-dark-fill': 'iconamoon:mode-dark-fill',
  'material-symbols:light-mode-rounded': 'material-symbols:light-mode-rounded',
  'material-symbols:night-sight-auto-rounded': 'material-symbols:night-sight-auto-rounded',
  //
  'line-md:phone-call-twotone-loop': 'line-md:phone-call-twotone-loop',
  'material-symbols:lock-reset': 'material-symbols:lock-reset',
  'majesticons:open': 'majesticons:open',
  // To Remove
  'ic:round-refresh': 'ic:round-refresh',
  'eva:close-fill': 'eva:close-fill',
  'ph:sun-duotone': 'ph:sun-duotone',
  'ph:moon-duotone': 'ph:moon-duotone',
  'cil:contrast': 'cil:contrast',
  'ion:contrast-outline': 'ion:contrast-outline',
  'ph:align-left-duotone': 'ph:align-left-duotone',
  'ph:align-right-duotone': 'ph:align-right-duotone',
  'ic:round-fullscreen': 'ic:round-fullscreen',
  'ic:round-fullscreen-exit': 'ic:round-fullscreen-exit',
  'eva:done-all-fill': 'eva:done-all-fill',
  'eva:clock-outline': 'eva:clock-outline',
  'eva:search-fill': 'eva:search-fill',
  'ph:plugs-connected': 'ph:plugs-connected',
  'simple-icons:binance': 'simple-icons:binance',
} as const;

export default iconifyIcons;
